var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useCallback } from 'react';
import RedaktorLogin from './RedaktorLogin';
var RedaktorPage = function () {
    var _a = useState(false), isAuthenticated = _a[0], setIsAuthenticated = _a[1];
    var _b = useState(null), token = _b[0], setToken = _b[1];
    var _c = useState(true), isLoading = _c[0], setIsLoading = _c[1];
    var verifyToken = useCallback(function (tokenToVerify) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    return [4 /*yield*/, fetch('/api/auth/verify', {
                            method: 'GET',
                            headers: {
                                'Authorization': "Bearer ".concat(tokenToVerify),
                            },
                        })];
                case 1:
                    response = _a.sent();
                    if (response.ok) {
                        setToken(tokenToVerify);
                        setIsAuthenticated(true);
                    }
                    else {
                        localStorage.removeItem('redaktor_token');
                    }
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _a.sent();
                    console.error('Token verification failed:', error_1);
                    localStorage.removeItem('redaktor_token');
                    return [3 /*break*/, 4];
                case 3:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, []);
    useEffect(function () {
        // Check if user is already logged in
        var storedToken = localStorage.getItem('redaktor_token');
        if (storedToken) {
            // Verify token is still valid
            verifyToken(storedToken);
        }
        else {
            setIsLoading(false);
        }
        // Cleanup function to ensure proper unmounting
        return function () {
            // Reset any styles that might persist
            document.body.style.overflow = '';
        };
    }, [verifyToken]);
    var handleLoginSuccess = function (newToken, user) {
        setToken(newToken);
        setIsAuthenticated(true);
    };
    var handleLogout = function () {
        localStorage.removeItem('redaktor_token');
        setToken(null);
        setIsAuthenticated(false);
    };
    if (isLoading) {
        return (_jsx("div", { style: {
                minHeight: '100vh',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'linear-gradient(135deg, #FAF6E7 0%, #F7E9D2 100%)',
                margin: 0,
                padding: 0
            }, children: _jsx("div", { children: "Loading..." }) }));
    }
    if (!isAuthenticated) {
        return _jsx(RedaktorLogin, { onLoginSuccess: handleLoginSuccess });
    }
    return (_jsx("div", { style: {
            minHeight: '100vh',
            width: '100%',
            background: 'linear-gradient(135deg, #FAF6E7 0%, #F7E9D2 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
            margin: 0,
            boxSizing: 'border-box'
        }, children: _jsxs("div", { style: {
                maxWidth: '700px',
                width: '100%',
                textAlign: 'center',
                background: 'white',
                borderRadius: '16px',
                padding: '60px 40px',
                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)'
            }, children: [_jsx("h1", { style: {
                        color: '#7B2323',
                        fontFamily: 'Playfair Display, serif',
                        fontSize: '2.5rem',
                        marginBottom: '50px',
                        lineHeight: '1.4'
                    }, children: "\u041F\u0430\u043D\u0435\u043B \u0420\u0435\u0434\u0430\u043A\u0442\u043E\u0440 / Editor Panel" }), _jsxs("div", { style: {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '25px',
                        alignItems: 'center'
                    }, children: [_jsx("button", { onClick: function () { return window.location.href = '/'; }, style: {
                                display: 'inline-block',
                                background: 'linear-gradient(135deg, #8B3A3A 0%, #7B2323 100%)',
                                color: 'white',
                                textDecoration: 'none',
                                border: 'none',
                                padding: '20px 60px',
                                fontSize: '1.3rem',
                                fontWeight: '600',
                                borderRadius: '12px',
                                boxShadow: '0 6px 20px rgba(123, 35, 35, 0.3)',
                                transition: 'all 0.3s ease',
                                cursor: 'pointer',
                                minWidth: '250px'
                            }, onMouseEnter: function (e) {
                                e.currentTarget.style.transform = 'translateY(-2px)';
                                e.currentTarget.style.boxShadow = '0 8px 25px rgba(123, 35, 35, 0.4)';
                            }, onMouseLeave: function (e) {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 6px 20px rgba(123, 35, 35, 0.3)';
                            }, children: "Go to Main Page" }), _jsx("button", { onClick: handleLogout, style: {
                                display: 'inline-block',
                                background: 'linear-gradient(135deg, #DC3545 0%, #C82333 100%)',
                                color: 'white',
                                border: 'none',
                                padding: '18px 60px',
                                fontSize: '1.2rem',
                                fontWeight: '600',
                                borderRadius: '12px',
                                boxShadow: '0 6px 20px rgba(220, 53, 69, 0.3)',
                                transition: 'all 0.3s ease',
                                cursor: 'pointer',
                                minWidth: '250px'
                            }, onMouseEnter: function (e) {
                                e.currentTarget.style.transform = 'translateY(-2px)';
                                e.currentTarget.style.boxShadow = '0 8px 25px rgba(220, 53, 69, 0.4)';
                            }, onMouseLeave: function (e) {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 6px 20px rgba(220, 53, 69, 0.3)';
                            }, children: "Logout" })] })] }) }));
};
export default RedaktorPage;
